import React from "react"
import { Col, ControlLabel, Form, FormGroup, Radio } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import {
  RevenueType,
  validatePercentState,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import FormButtons from "../../fragments/FormButtons"
import FormControlInput from "../../fragments/FormControl.Input"

class FormFinancierBucket extends React.Component {

  constructor(props) {

    super(props)
    const { financierBucket } = this.props,
    isNew = !financierBucket

    this.state = {

      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : financierBucket.name,
      revenueType: isNew ? RevenueType.FIXED_RATE : financierBucket.revenueType,
      rate: isNew ? '' : financierBucket.rate,
      nameValidationState: VALIDATION_TYPE.NULL,
      revenueTypeValidationState: VALIDATION_TYPE.SUCCESS,
      rateValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {

    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  revenueTypeChanged = revenueType => this.setState({
    revenueType,
    revenueTypeValidationState: validateTextState(revenueType, false),
    error: null
  })

  rateChanged = rate => this.setState({
    rate,
    rateValidationState: validatePercentState(rate, false),
    error: null
  })

  validateAllValues = () => {

    const { name, revenueType, rate } = this.state,
    nameValid = validateTextState(name, false),
    revenueTypeValid = validateTextState(revenueType, false),
    rateValid = validatePercentState(rate, false)

    this.setState({
      nameValidationState: nameValid,
      revenueTypeValidationState: revenueTypeValid,
      rateValidationState: rateValid
    })

    return nameValid === VALIDATION_TYPE.SUCCESS
      && revenueTypeValid === VALIDATION_TYPE.SUCCESS
      && rateValid === VALIDATION_TYPE.SUCCESS
  }

  saveData = () => {

    if(!this.validateAllValues()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, revenueType, rate } = this.state,
    data = { name, revenueType, rate },
    { financierBucket } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createFinancierbucket(accessToken, data)
        : apiServerApi.updateFinancierbucket(accessToken, financierBucket.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/financiers/buckets'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderRevenueType = (revenueType, revenueTypeValidationState, running) => (
    <FormGroup controlId='revenueType' validationState={ revenueTypeValidationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        Revenue type
      </Col>

      <Col sm={8} className='mb-10'>

        <Radio
          name="revenueType1" 
          onClick={() => this.revenueTypeChanged(RevenueType.FIXED_RATE)}
          checked={ revenueType === RevenueType.FIXED_RATE }
          disabled={ running }
          onChange={() => null}
        >
          Fixed rate
        </Radio>

        <Radio
          name="revenueType2" 
          onClick={() => this.revenueTypeChanged(RevenueType.SHARING)}
          checked={ revenueType === RevenueType.SHARING }
          disabled={ running }
          onChange={() => null}
        >
          Revenue sharing
        </Radio>
      </Col>
    </FormGroup>
  )

  renderRevenueSharing = (rate, aionSolRevenue, rateValidationState, running) => (
    <FormGroup controlId='investorRevenue' validationState={ rateValidationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        Revenue sharing (%)
      </Col>

      <Col sm={8}>
        <Col xs={7}>

          <FormControlInput
            validationState={ rateValidationState }
            value={ rate } placeholder='Rate'
            label='Investor'
            onChange={ this.rateChanged }
            help={ rateValidationState === VALIDATION_TYPE.ERROR ? 'Invalid value' : '' }
            disabled={ running }
            hasFeedback
          />
        </Col>

        <Col xs={5}>
          <FormControlInput
            validationState={ VALIDATION_TYPE.NULL }
            value={ aionSolRevenue }
            label='Aion Sol' className='pl-10'
            disabled
          />
        </Col>
      </Col>
    </FormGroup>
  )

  renderForm = () => {

    const { isNew, error, success, running, name, revenueType, rate,
      nameValidationState, revenueTypeValidationState, rateValidationState } = this.state,

    { financierBucket } = this.props,

    aionSolRevenue = (rate !== '' && rate >= 0 && rate <= 100) 
      ? 100 - rate : '',

    bucketName = financierBucket ? financierBucket.name : 'Bucket'

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveData()}}>

          <h3 className="text-center">
            { isNew ? 'Create' : 'Update' } { bucketName }
          </h3>
          <hr />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name'
            value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
            disabled={ running }
          />

          { this.renderRevenueType(revenueType, revenueTypeValidationState, running) }

          { revenueType === RevenueType.FIXED_RATE ?

          <FormControlInlineInput controlId="rate" validationState={ rateValidationState }
            label='Fixed rate (%)' placeholder='Rate'
            value={ rate }
            onChange={ this.rateChanged }
            helpText={ rateValidationState === VALIDATION_TYPE.ERROR ? 'Invalid value' : '' }
            disabled={ running }
          />
          : this.renderRevenueSharing(rate, aionSolRevenue, rateValidationState, running) 
          }
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <FormButtons
          onSave={ this.saveData }
          onCancel={() => browserHistory.push('/financiers/buckets')}
          running={ running }
        />
      </div>
    )
  }

  render() {

    const { isNew } = this.state,
    dataBreadCrumbs = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/buckets', title: 'Buckets' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

export default FormFinancierBucket



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/Form.js